import type {
    InputFontSize,
    InputSize,
    InputVariant,
} from "@design-system/Input/Input.types";

/**
 * The variant × size availability matrix from
 * `docs/specs/2026-09-15-input-figma-rework.md`, mirrored here so the
 * playground only ever offers combinations the component's type union allows.
 */
export const inputVariants = [
    "primary",
    "ghost",
    "accent",
] as const satisfies readonly InputVariant[];

export const allSizes = ["md", "lg", "xl"] as const;
export const compactSizes = ["md"] as const;

export const sizeOptionsByVariant = {
    primary: allSizes,
    ghost: compactSizes,
    accent: compactSizes,
} as const satisfies Record<InputVariant, readonly InputSize[]>;

/** Matches the component's own fallback, and the only legal size off primary. */
export const defaultInputSize = "md" as const satisfies InputSize;

/** Ghost is the only variant Figma draws at 12px, so this axis is ghost-only. */
export const inputTextSizes = ["14", "12"] as const;

export type InputTextSize = (typeof inputTextSizes)[number];

export const toFontSize = (textSize: InputTextSize): InputFontSize =>
    textSize === "12" ? 12 : 14;
